export const NAMESPACE = {
  dataSynonymId: 'data-synonym-id', // будет использоваться для получения выбранного синонима
  dataSynonymTypeId: 'data-synonym-type-id', // будет использоваться для получения выбранного типа синонима(dtypeId из дерева синонимов)
  synonymListMountNode: window.MOBILE_VERSION ? '.b-list-card__mount-selects' : '.b-card-services__calendar-selects',
  scheduleLoaded: 'schedule-loaded',
  mobileCalendarLoaded: 'b-list-card__slots_loaded',
  appointmentButtonDesktop: '.b-card__appointment_js',
  appointmentButtonMobile: '.b-list-card__appointment-box_js',
} as const
